/* eslint-disable react/no-danger */
/* eslint-disable max-len */
import React from 'react';

export default props => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      id="svg8"
      version="1.1"
      viewBox="0 0 14 14"
      height="14"
      width="14"
      {...props}
    >
      <g id="layer1">
        <path
          d="m 7.5000002,1.0000002 v 1 A 4.9999997,4.9999997 0 0 1 12.5,7.0000003 4.9999997,4.9999997 0 0 1 7.5000002,12.000001 4.9999997,4.9999997 0 0 1 2.5,7.0000003 h -1 A 6.0000001,6.0000001 0 0 0 7.5000002,13 6.0000001,6.0000001 0 0 0 13.5,7.0000003 6.0000001,6.0000001 0 0 0 7.5000002,1.0000002 Z"
          style={{ fill: '#000000', 'stroke-width': 0 }}
          id="path851"
        />
        <path
          d="M 4,7.1666669 H 0 L 2.0000001,4.5 Z"
          style={{ fill: '#000000', 'stroke-width': 0 }}
          id="path872"
        />
      </g>
    </svg>
  );
};
